import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Button,
         Container,
         } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes,
         faSun,
         faExpand,
         faEye,
         faPlayCircle,
         } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import { decodeVideoHash,
         arrayTargetHashAscSort,
         arraySourceTimestampDesSort,
         downloadEmbededVideos,
         processGifVideo,
         makeVideoLink, } from "../util/util";
import { CONSTS, INFO, CONSLOG } from '../util/object'
import { GATag } from "../util/tools";
import { UTIL_useStyles,
         Avatar, 
        } from "../components/Util";
import Carousel from 'react-bootstrap/Carousel'     // sudo yarn add  react-bootstrap bootstrap@5.0.2
       // ref: https://dzone.com/articles/how-to-use-bootstrap-carousel-in-reactjs

import marquee_styles from '../styles/animation.module.css'    // test
import { VideoPlayerClass } from '../class/VideoPlayerClass';        // abstraction
import VimeoPlayer from '@vimeo/player';
import YouTube from 'react-youtube';        // src: https://github.com/tjallingt/react-youtube
import { ReadDetect, CreateDetect, InsertDetect } from '../util/database';
import { LoadingBars  } from '../util/spinner'; 




// control vimeo player via API
// src: https://developer.vimeo.com/player/sdk/reference
// API ref: https://www.npmjs.com/package/@vimeo/player?activeTab=readme
export function setPlayerSpeed(player, speed) {
    GATag("Learn", "Video.SetSpeed", speed, 0);  // (cat, act, lab, val)
    if ((player === null) || (player === undefined)) {
        return;     // not ready
    }

    var iframe = document.querySelector("iframe");  // document.getElementById("drill_output");
    if ((iframe !== null) && (iframe !== undefined)) {
        INFO.video_owidth = iframe.offsetWidth;		// this does not change
        INFO.video_oheight = iframe.offsetHeight;
        //console.log("train_slowmo.1221:       CHANGE PLAY SPEED TO ", speed, " v.owd=", INFO.video_owidth, " v.oht=", INFO.video_oheight, );
        try {
            player.setSpeed(speed)       // player.setPlaybackRate(speed)
            .then(()=>{
                //console.log("train_slowmo.424:       CHANGE PLAY SPEED TO ", speed);
            })
        }
        catch {
            //console.log("train_slowmo.460:  NOT A VIMEO PLAYER");
            //setSlowMo(false); <<<<<
        }
        //setRefresh(Date.now());
    }
}




// skip to different time on the video
//
export async function setPlayerTime(player, pct, move) {
    var duration, cur_time = 0, new_time = 0, pause = false;

    if ((player === null) || (player === undefined)) {
        return;
    }

    if ((pct !== null) && (pct !== undefined)) {
        // jump to a set position
        //
        duration = await player.getDuration();
        new_time = duration * (pct / 100)
    } else {
        // single step skim
        //
        if ((move === null) || (move === undefined)) {
            console.log("vimeo_time.1012:  START PLAYING  pct=",pct, " move=",move);        //, " ",player);
            player.start();     // player.play();
            return;
        }

        pause = true;
        cur_time = await player.getTime(); //cur_time = await player.getCurrentTime();
        new_time = cur_time + (move / 10);     // move is in 100 msec
    }

    //console.log("vimeo_time.1006:      CHANGE TIME TO ", new_time.toFixed(3), " pct=",pct, " duration=",duration, " move=",move, " curr=",cur_time.toFixed(3), " pause=",pause, " v.owd=", INFO.video_owidth, " v.oht=", INFO.video_oheight);     //, " ",player);
    player.setTime(new_time) //player.setCurrentTime(new_time)

    if (pause === true) {
        player.pause();
    }

}




// <VideoFrame>  - video display container
//     - also reference <VideoFeed>
//     - it is important to be able to get the absolute x-y of the video, so touch will work across device
//
// div alignment is tricky
// src: https://css-tricks.com/fluid-width-video/
const videof_useStyles = makeStyles(theme => ({
    vimeo_iframe: {
        position: 'absolute',
        top: '0',
        left: '0',
        margin: '0',
        padding: '0',
        zIndex: '100',
        background: '#5c5b5b',
        //objectFit: 'none',      // fill, cover, contain, scale-down, none
        //width: '100%',
        //height: '100%',
    },

    player_container: {
        position: 'relative',
        top: '0',
        left: '0',
        margin: '0',
        padding: '0',
        zIndex: '100',
        width: '100%',
        height: '100%',
    },

    player_native_container: {
        position: 'absolute',   //'relative',
        top: '0',       //'45px',
        left: '0',
        padding: '0',
        margin: '0',
        zIndex: '100',
        width: '100%',
        height: '100%',
        background: '#888',
        //transform: 'translateY(-150px)',
    },

    //560  315
    youtube_iframe: {
        position: 'absolute',
        top: '0',
        left: '0',
        transform: 'translateY(-200px)',
        clipPath: 'inset(200px 0 200px 0)',
    },

}));

// vimeo: https://player.vimeo.com/video/   537979645   ?autoplay=1&loop=1&autopause=1&muted=1&controls=0
// youtube: https://youtu.be/  v4VDtQV3Knw  ?t=8
// yt.embed: https://www.youtube.com/embed/ v4VDtQV3Knw  ?start=8
// src="https://www.youtube.com/embed/v4VDtQV3Knw" 
//       - yt_video_box: class="ytp-iv-video-content"

//  NOTE:  THIS IS NOT WORKING DUE TO RACE CONDITION, FRAME NEED TO RENDERED BEFORE INSTALL VIMEO PLAYER!!
//      - or move the code up to <Learn>
//
export const VideoFrame = (props) => {
    const classes = videof_useStyles();
    //const [ VimeoType, setVimeoType ] = useState(true);
    const [ VideoURL, setVideoURL ] = useState(null);
    const [ VideoID, setVideoID ] = useState(null);
    const [ VideoHash, setVideoHash ] = useState(null);     // for compare new one
    const [ VideoTimer, setVideoTimer ] = useState(null);
    const [ Start, setStart ] = useState(null);
    const [ End, setEnd ] = useState(null);
    const [ Opts, setOpts ] = useState({});
    const [ VideoPlayer, setVideoPlayer ] = useState(null);
    const [ GifDone, setGifDone ] = useState(false);

    useEffect(() => {

        console.log("video.181:  ~  ~  ~  ~  ~  ~  ~  ~  ~  ~  START <VIDEOFRAME>    ", props);

        return function cleanup() {
            console.log("video.4075:  ~  ~  ~  ~  ~  ~  DESTROY VIDEO PLAYER (TEMP DISABLED)  ", INFO.mock_player);
            if (INFO.video_timer !== null) {
                clearTimeout(INFO.video_timer);
                INFO.video_timer = null;
                //INFO.yt_video_player = null;
            }

        }
    }, [1]);


    useEffect(() => {
        // react refresh
        console.log("opts.202 ~  ~  ~  ~  ~  REFRESH   PlayerType=",props.PlayerType);
    }, [props.PlayerType]);


    useEffect(() => {
        // react refresh
        console.log("opts.195:  ~  ~  ~  ~  ~  ~  OPTS REFRESH   opts=",Opts);
    }, [Opts]);
    //}, [VideoID, Opts]);


    useEffect(() => {
        console.log("video.4311:  ~  ~  ~  ~  ~  ~  URL REFRESH   url=",VideoURL, "  videoID=",VideoID);
    }, [VideoURL, VideoID]);
    //}, [VideoURL]);


    useEffect(() => {
        if ((props.Width === null) || (props.Height === null)) {
            return;
        }

        //var youtube_kludge = (INFO.practice_mode === true) ? 0 : CONSTS.YOUTUBE_VERTICAL_KLDUGE;        // need this?
        //var youtube_kludge = (VimeoType === false) ? CONSTS.YOUTUBE_VERTICAL_KLDUGE : 0;        // need this?
        var youtube_kludge = (props.PlayerType === "youtube") ? CONSTS.YOUTUBE_VERTICAL_KLDUGE : 0;        // need this?

        var width = props.Width.toString().replace("px","")+"px";
        var height = (parseInt(props.Height.toString().replace("px",""))+youtube_kludge)+"px";
        //var height = (parseInt(props.Height.toString().replace("px","")))+"px";
        //var height = (parseInt(props.Height.toString().replace("px","")) + 400)+"px";

        //console.log("video.220:         PRE READJUST  width=",width,"  height=",height, " props.Height=",props.Height,"  yt_kludge=",youtube_kludge, "  practice_mode=",INFO.practice_mode);

        //if (VimeoType === true) {
        if (props.PlayerType === "vimeo") {
            var iframe = document.querySelector('#drill_output');

            //iframe.style.width = props.Width.toString()+"px";       // not iframe.clientWidth
            //iframe.style.height = props.Height.toString()+"px";
            iframe.style.width = width;
            iframe.style.height = height;
            //console.log("video.218:          READJUST VIMEO SIZE   width=",iframe.style.width, " height=",iframe.style.height);

        } else  if (props.PlayerType === "youtube") {
            var opts = {...Opts};
            //opts.width = props.Width.toString()+"px";
            //opts.height = props.Height.toString()+"px";
            opts.width = width;
            opts.height = height;
            //console.log("video.226:          READJUST YOUTUBE SIZE   height=",opts.height," opts=",opts, "  props=",props);
            setOpts(opts);
        } else  if (props.PlayerType === "native") {
            var video = document.querySelector('#drill_output');

            //iframe.style.width = props.Width.toString()+"px";       // not iframe.clientWidth
            //iframe.style.height = props.Height.toString()+"px";
            video.width = width;
            video.height = height;
            //console.log("video.256:          READJUST NATIVE SIZE   width=",video.width, " height=",video.height);

        }

    }, [props.Width, props.Height]);


    useEffect(() => {
        var source = null;
        var footage = props.Footage;
        var hash = (footage) ? footage.hash : (props.SelectedItem.video_hash) ? props.SelectedItem.video_hash : VideoURL;

        //if ((!hash) || (!props.SelectedItem) || (!VideoID) && (!VideoURL)) {
        if (((!hash) || (!props.SelectedItem)) && (!VideoID) && (!VideoURL)) {
            console.log("vid.367:    ! ! ! ! ! ! SKIP VIDEO SETUP   hash=",hash, " props.SelectedItem=",props.SelectedItem, " VideoID=",VideoID, " VideoURL=",VideoURL, " time=",parseInt(performance.now()));
            return;
        }
        console.log("vid.345:     . . . . vidURL.useEffect(): PROCESS VIDEO SETUP   hash=",hash, " footage=",footage, " item=",props.SelectedItem, " VideoURL=",VideoURL);   //, " props.SelectedItem=",props.SelectedItem, " VideoID=",VideoID, " VideoURL=",VideoURL, " time=",parseInt(performance.now()));

        var video_id = null, video_start = null, video_end = null, width = null, height = null;
        var ytkludge = (props.PlayerType === "youtube") ? CONSTS.YOUTUBE_VERTICAL_KLDUGE : 0;
        if ((footage !== null) && (footage !== undefined)) {
            // From <Mock>: use footage info
            //
            video_id = footage.video_id;
            video_start = footage.start;
            video_end = footage.end;
            width = footage.width
            height = parseInt(footage.height) + ytkludge;
        } else {
            // From <Learn>: use props info
            //
            if ((props.Width === null) || (props.Height === null)) {
                return;     // have neither footage nor per video dim
            }

            //width = props.Width.toString().replace("px","");
            //height = parseInt(props.Height.toString().replace("px","")) + CONSTS.YOUTUBE_VERTICAL_KLDUGE;
            //var ytkludge = (VimeoType === true) ? 0 : CONSTS.YOUTUBE_VERTICAL_KLDUGE;
            width = props.Width.toString().replace("px","")+"px"; 
            height = (parseInt(props.Height.toString().replace("px","")) + ytkludge)+"px";
            console.log("vid.388:        .  .  .  .  props.width=",props.Width, " props.height=",props.Height, "  new_height=",height);
        }

        console.log("vid.339:     . . . . vidURL.useEffect(): PROCESS VIDEO SETUP   VideoID=",VideoID, " hash=",hash, " footage=",footage, " PlayerType=", props.PlayerType, " time=",parseInt(performance.now()));     //" VideoURL=",VideoURL, 


        // create new abstract player
        //
        //if (VimeoType === true) 
        if (props.PlayerType === "vimeo") {
            if (hash) [ video_id, video_start, video_end ] = decodeVideoHash(hash);
            console.log("vid.242:         VIMEO URL DECODED  id=",video_id, " video_start=",video_start, " video_end=",video_end, " hash=",hash, " VideoHash=",VideoHash);
            INFO.video_start = (video_start === 0) ? null : video_start;
            INFO.mock_video_id = video_id;
            source = "vimeo";

            //if ((VideoPlayer === null)) 
            //if (true && (VideoPlayer === null)) 
            //if (true || (hash !== VideoHash)) 
            if ((VideoPlayer === null) || (hash !== VideoHash)) {
                setVideoHash(hash);     // don't create new player for same video
                setTimeout(() => {
                    var player = setupVideoPlayer("vimeo", "url.vimeo.244");
                    console.log("video_frame.378:   ~~~~~~~~~~~~  ADD NEW VIMEO PLAYER    hash=",hash, " VideoHash=",VideoHash,"  video_id=",video_id, " time=",parseInt(performance.now()));
                    setVideoPlayer(player);
                    if ((player !== null) && (player.getURL() === true)) {

                        console.log("video_frame.391:                GOOD VIMEO PLAYER  url=",player.getURL()); //," onReady=",props.onReady);
                        // set up vimoe event listners HERE!!!
                        // [events: bufferend, bufferstart, chapterchange, chromecastconnected, controlbarvisibilitychanged, 
                        //          cuechange, cuepoint, durationchange, ended, error, fullscreenchange, 
                        //          loadeddata, loadstart, loadedmetadata, loaded, pause, play, playing, playbackratechange, 
                        //          ratechange, progress, qualitychange, ready, resize, seeking, seeked, 
                        //          spacechange, texttrackchange, timeupdate, volumechange, waiting ]
                        //
                        INFO.mock_player = player;      // React vars are flaky, wrapper player
                        player.setEventHandler(handleVimeoOnStateChange);

                        if (props.Loop === true) {
                            player.setTime(INFO.video_start);
                            player.pause();
                        }

                        props.onReady(player);        // pass abstract player up
                    }
                }, 250);
            } else {
                console.log("video_frame.410:   ~ ~ ~ ~ ~ ~   REUSE VIMEO PLAYER    hash=",hash, " VideoHash=",VideoHash,"  VideoPlayer=",VideoPlayer, " time=",parseInt(performance.now()));
                props.onStateChange("ready");     // send it up
            }


        } else if (props.PlayerType === "youtube") {
            // youtube only code
            //    - below code suports <react-youtube>
            //    - it sets up the params, then react creates the player and we get it on callback
            //    - operations are called at higher level, via VideoPlayer object
            //
            if (hash) [ video_id, video_start, video_end ] = decodeVideoHash(hash);
            console.log("vid.396:        YOUTUBE OPTS PREP .  .  .  .  video_id=",video_id, " hash=",hash, " width=",width, " height=",height);
            //INFO.video_start = video_start;
            INFO.video_start = (video_start === 0) ? null : video_start;
            source = "youtube";
            var opts = {
                    width:  width,      // 100%
                    height: height,     //parseInt(height) + 400, auto
                    playerVars: {
                        // https://developers.google.com/youtube/player_parameters
                        videoId: video_id,
                        start: video_start,
                        end: video_end,
                        modestBranding: 1,
                        controls: 0,
                        loop: 1,
                        autoplay: 1,
                        enablejsapi: 1,
                        rel: 0,
                    }
                };
            setVideoID(video_id);       // must have this for <YouTube> to work!
            setOpts(opts);
            setStart(video_start);
            setEnd(video_end);
            INFO.video_play_secs = (video_end && video_start) ? video_end - video_start : 9999;
            INFO.mock_video_id = video_id;
            console.log("vid.294:         YOUTUBE URL DECODED  hash=",hash, " id=",video_id, " video_start=",video_start, " video_end=",video_end, " opts=",opts);


            if ((VideoPlayer === null) || (hash !== VideoHash)) {
            //if ((VideoPlayer === null)) 
            //if (true && (VideoPlayer === null)) 
            //if (true || (hash !== VideoHash)) 
                setVideoHash(hash);
                setTimeout(() => {
                    var player = setupVideoPlayer("youtube", "url.youtube.315");
                    console.log("video_frame.318:   ~~~~~~~~~~~~  YOUTUBE TYPE DETECED, PLAYER COMING...    player=",player); // late binding
                    INFO.mock_player = player;      // React vars are flaky
                    setVideoPlayer(player);         // does this work from timer? 
                    INFO.youtube_player = true;   // KLUDGE: need this for adjustDisplayDiv()....MUST FIX!

                    //player.setTime(INFO.video_start);
                    //props.onReady(player);        // NOT YET...wait until yt_player ready
                }, 250);
            } else {
                console.log("video_frame.470:   ~ ~ ~ ~ ~ ~   REUSE YOUTUBE PLAYER    hash=",hash, " VideoHash=",VideoHash, " opts=",Opts,"  VideoPlayer=",VideoPlayer, " time=",parseInt(performance.now()));
            }


        } else if (props.PlayerType === "native") {

            //if (hash) [ video_id, video_start, video_end ] = decodeVideoHash(hash);
            //console.log("vid.491:         NATIVE URL DECODED  id=",video_id, " video_start=",video_start, " video_end=",video_end, " hash=",hash, " VideoHash=",VideoHash);
            //INFO.video_start = (video_start === 0) ? null : video_start;
            //INFO.mock_video_id = video_id;
            source = "native";
            if ((VideoPlayer === null) || (hash !== VideoHash)) {
                setVideoHash(hash);     // don't create new player for same video
                setTimeout(() => {
                    var player = setupVideoPlayer("native", "url.native.499");
                    console.log("video_frame.501:   ~~~~~~~~~~~~  ADD NEW NATIVE PLAYER    hash=",hash, " VideoHash=",VideoHash," player=",player,"   time=",parseInt(performance.now()));
                    setVideoPlayer(player);
                    player.setURL(VideoURL);

                    //if ((player !== null) && (player.getURL() === true)) {
                    if (player !== null) {
                        INFO.mock_player = player;      // React vars are flaky, wrapper player

                        console.log("video_frame.505:                HAS GOOD VIMEO PLAYER  url=",player.getURL()); //," onReady=",props.onReady);
                        if (props.Loop === true) {
                            player.setTime(INFO.video_start);
                            player.pause();
                        }
                        props.onReady(player);        // pass abstract player up
                    }
                }, 250);
            } else {
                console.log("video_frame.516:   ~ ~ ~ ~ ~ ~   REUSE VIMEO PLAYER    hash=",hash, " VideoHash=",VideoHash,"  VideoPlayer=",VideoPlayer, " time=",parseInt(performance.now()));
                props.onStateChange("ready");     // send it up
            }
        }
    }, [VideoID, VideoURL]);





    //   - [nope, need this for non-mock!]  RETIRE THIS SOON WITH FOOTAGE
    //
    useEffect(() => {
        if ((props.Source === null) || (props.Source === undefined)) {
            return;
        }


        // figure out if it's vimeo or youtube
        var url = makeVideoLink(props.Source, "video_frame.4110");
        var is_vimeo = (url.includes("youtu") === true) ? false : true;
        //INFO.yt_video_player = null;
        //INFO.vimeo_player = null;

        //setVimeoType(is_vimeo);     // triggers video player setup
        //setPlayerType(props.PlayerType);     // triggers video player setup
        setVideoURL(url);   // need 0&enablejsapi=1"

        var [ video_id, video_start, video_end ] = decodeVideoHash(props.Source);
        setVideoID(video_id);     // <==== for youtube link chg....need to fix
        console.log("video.4083:             ~ ~ ~ ~ ~ ~ INIT VideoFrame......   url=",url, " video_id=",video_id);   //Source=",props.Source,
        //const url = "https://player.vimeo.com/video/"+props.Source+VIMEO_POST;

    }, [props.Source]);


    useEffect(() => {
        var footage = props.Footage;
        if ((footage === null) || (footage === undefined)) {
            return;
        }

        var is_vimeo = (footage.source === "vimeo") ? true : false;
        //INFO.yt_video_player = null;
        //INFO.vimeo_player = null;
        console.log("video.439:            ~ ~ ~ ~ ~ INIT VideoFrame Footage... is_vimeo=",is_vimeo);  // props.Footage=",props.Footage, " props.Item=",props.SelectedItem, 

        //setVimeoType(is_vimeo);

        setVideoURL(INFO.video_url);   // need 0&enablejsapi=1"
        setVideoID((footage.video_id).toString());

    }, [props.Footage]);

    
    // create video player wrapper object
    //
    function setupVideoPlayer(type, from) {
        var speed = 2;
        GATag("Player", "Video.Setup", speed, 0);  // (cat, act, lab, val)

        //var iframe = document.getElementById("drill_output");   // document.querySelector("iframe");
        //var iframe = (type === "native") ?  document.getElementById("video") : document.getElementById("drill_output");   // 
        var iframe = (type === "native") ?  document.getElementById("drill_output") : document.getElementById("drill_output");   // 
        console.log("video_frame.602:             ~ ~ ~ ~ ~  VIDEO PLAYER SETUP    type=",type, " from=",from); //, "  iframe=",iframe);
        if ((iframe !== null) && (iframe !== undefined)) {
            INFO.video_owidth = iframe.offsetWidth;		// this does not change
            INFO.video_oheight = iframe.offsetHeight;
            try {

                var player = new VideoPlayerClass(iframe, from);
                player.setType(type);       // also setup vimeo state event listeners
                console.log("video_frame.270:            ~ ~ ~ ~ ~  ** NEW ** VIDEO PLAYER SETUP   type=",type, " from=",from);    //, player);

                return player;
            }
            catch (err) {
                console.log("video_frame.275:  ~~~~~~~~~~~ NOT A VIDEO PLAYER  player=",player, " err=",err);
            }
        } else {
            console.log("video_frame.278:  ~~~~~~~~~~ NO VIDEO IFRAME  iframe=",iframe);
        }

        return null;
    }


    /////////////////////////////////////////////////////////////////////////////
    //   VIMEO PLAYER SPECIFIC ROUTINES
    //

    //
    // control vimeo player via API
    // src: https://developer.vimeo.com/player/sdk/reference
    // API ref: https://www.npmjs.com/package/@vimeo/player?activeTab=readme
    // HTML ref: https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement
    //     [ abort, canplay, ended, error, loadeddata, pause, play, playing, progress, seeked, waiting, stalled]
    //    - catch all events: https://stackoverflow.com/questions/5107232/is-it-possible-to-programmatically-catch-all-events-on-the-page-in-the-browser
    //
    const handleVimeoOnLoadeddata = (event) => {
        console.log("vframe.428:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON LOADED DATA",event);
    }
    const handleVimeoOnReady = (event) => {
        console.log("vframe.444:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON READY? ",event);
    }
    const handleVimeoOnPlay = (event) => {
        console.log("vframe.436:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON PLAY",event);
    }
    const handleVimeoOnPlaying = (event) => {
        //console.log("vframe.432:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON PLAYING",event);
    }
    const handleVimeoOnSeeked = (event) => {
        //console.log("vframe.449:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON SEEKED ",event);
    }
    const handleVimeoOnProgress = (event) => {
        //console.log("vframe.422:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON PROGRESS ",event);
    }
    const handleVimeoOnEnded = (event) => {
        console.log("vframe.431:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON ENDED",event);
    }
    const handleVimeoOnPause = (event) => {
        //console.log("vframe.440:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON PAUSE",event);
    }
    const handleVimeoOnWaiting = (event) => {
        //console.log("vframe.449:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON WAITING ",event);
    }
    const handleVimeoOnError = (event) => {
        console.log("vframe.431:        ~~~~~~~~~~~~ Handle <VideoFrame> VIMEO ON ERROR",event);
    }




    // called from class object
    //
    const handleVimeoOnStateChange = (event) => {
        var url = null;
        /*
        if ((GifDone === false) && (event === "pause")) {
            //url = downloadEmbededVideos();
            //processGifVideo(url);
            //setGifDone(true);
        }
        */
        //console.log("player.596        = = = = = = = = = =  Handle VIMEO STATE CHANGE   event=", event, " url=",url);

        props.onStateChange(event);     // send it up

    }


    const handleNativeOnReady = (event) => {
        var player = event.target;
        if (player) {
            if (VideoPlayer) {
                VideoPlayer.bind(player);     // custom bind method to support <reactive-youtube> timing
                console.log("vframe.674:        ~~~~~~~~~~~~ Handle <VideoFrame> NATIVE FIRST READY   vid_start=",INFO.video_start, " player=",player, " VideoPlayer=",VideoPlayer);
                VideoPlayer.pause();
            }

            props.onReady(VideoPlayer);      // pass player up so it can be controlled
        }
    }


    const handleNativeOnStateChange = (event) => {
        //console.log("player.701        = = = = = = = = = =  Handle NATIVE STATE CHANGE   event=", event);
        props.onStateChange(event);     // send it up
    }



    /////////////////////////////////////////////////////////////////////////////
    //   YOUTUBE PLAYER SPECIFIC ROUTINES
    //

    // youtube player LATE BINDING to wrapper
    // API: https://developers.google.com/youtube/iframe_api_reference
    //
    // PlaybackRates:   [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
    //
    const handleYoutubeOnReady = (event) => {
        var ytplayer = event.target;
        if (ytplayer && VideoPlayer) {
            VideoPlayer.bind(ytplayer);     // custom bind method to support <reactive-youtube> timing
            console.log("vframe.430:        ~~~~~~~~~~~~ Handle <VideoFrame> Youtube FIRST READY   vid_start=",INFO.video_start, " opts=",Opts,"  player.url=",ytplayer.playerInfo.videoUrl);
            VideoPlayer.pause();

            props.onReady(VideoPlayer);      // pass player up so it can be controlled
        }
    }


    // youtube only
    //
    const handleYoutubeOnStateChange = (event) => {
        const YTSTATUS = ["UNSTARTED", "ENDED", "PLAYING", "PAUSED", "...BUFFERING", "UNKNOWN", "CUED"];
        var player = event.target;
        var state = player.getPlayerState();
        //-1 (unstarted)
        // 0 (ended)
        // 1 (playing)
        // 2 (paused)
        // 3 (buffering)
        // 5 (video cued)
        switch (state) {
            case 0:     // ended
            case 2:     // paused
                break;
            case 1:     // playing
                //console.log("vframe.4468:        ~~~~~~~~~~~~ Handle Youtube PLAYING  exec=",INFO.mock_execute, " annotate=",INFO.annotate);
                // manual stop with a timer
                //
                if ((props.Loop === true) && (INFO.video_play_secs > 1)) {
                    var timer = setTimeout(process_yt_loop_timeout.bind(this), INFO.video_play_secs * 1000);
                    INFO.video_timer = timer;       // NOTE: CAN NOT USE REACT VARS IN HANDLER
                    //setVideoTimer(timer);
                }

                break;
            case 5:     // cued
                console.log("vframe.4476:        ~~~~~~~~~~~~ Handle Youtube PLAY CUED   playlist=", player.getPlaylist());
                /*
                player.loadVideoById({'videoId': VideoID,
                        'startSeconds': Start,
                        'endSeconds': End});
                player.loadPlaylist([VideoID], 0, Start);
                */
                //player.nextVideo();

                break;
        }

        console.log("        ~~~~~~~~~~~~ Handle Youtube STATE CHANGE   ", YTSTATUS[state+1], "  state=",state);
        props.onStateChange(event);     // send it up
    }


    // youtube only
    // Using timeout to stop video and loop the playlist is better than using the player stop-end
    //
    function process_yt_loop_timeout()  {
        //var player = INFO.yt_video_player;
        var player = INFO.mock_player;
        if (player !== null) {
            console.log("youtube.656:   .......GOT VIDEO TIMEOUT!   After ",INFO.video_play_secs.toFixed(3));  //player=",player);
            //player.stopVideo();     // this puts player into "cue" state, thenn we call nextVideo()
            player.setTime(INFO.video_start);
        }
    }



    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   VIDEO PLAYER HANDLER ROUTINES  (check MOck.js)
    //
    const handlePlayerPlay = async (event) => {
        var player = INFO.mock_player;
        //var paused = await player.getPaused();
        var paused = player.paused;  // do we really need this?  takes awhile
        if (paused == true) {
            //console.log("mock.515:          KEY START VIDEO  ");    //player=",player);
            player.start();
        } else {
            //console.log("mock.518:          KEY PUASE VIDEO  ");    //player=",player);
            player.pause();
        }
    }


    // control video steps
    //    - if in running mode, step by detect
    const handlePlayerStep = (steps) => (event) => {
        var player = INFO.mock_player;

        console.log("mock.1611:       HANDLE SINGLE STEP   steps=",steps);
        player.singleStep(steps);

        /*
        if (Math.abs(steps) > 30) {
            //processPlayerSkip(steps);       // may skip to next detect based on mode
        } else {
            console.log("mock.1611:       HANDLE SINGLE STEP   steps=",steps);
            player.singleStep(steps);
        }*/
    }


    // NOTE: take out (event) IF not calling directly from onClick()!
    //
    const handlePlayerSpeed = (speed) => {
        console.log("mock.1074:     . . . . CHANGE SPEED TO ", (speed*100));
        var player = INFO.mock_player;
        INFO.mock_playing_speed = speed;
        player.setSpeed(INFO.mock_playing_speed); 
    }


    /* if alt key then skip to end or begining of the detect sequence
    //
    const processPlayerSkip = async (steps, ctrl, alt) => {
        var player = INFO.mock_player;
        var detects = INFO.mock_detects[INFO.mock_type];

        if ((Math.abs(steps) > 30) && ((detects) && (detects.length > 0))) {

            var start = await findNextDetect(steps, ctrl, alt);
            if (start !== null) {      // NOTE: Can not use "">= 0"?!?
                INFO.mock_debug && console.log("mock.1896:       SKIP  steps=",steps, " start=",start, " alt=",alt);
                player.setTime(start - (CONSTS.MOCK_DISPLAY_PREVIEW/1000));
                return;
            }
            console.log("mock.1715:       FAILED SKIP  steps=",steps, " start=",start, " detects=",detects);
        }

        //console.log("mock.1717:       SINGLE STEP  steps=",steps, " detects=",detects);
        player.singleStep(steps);
        //checkDetectBoundary(steps);
    } */





                //<div id="drill_output_box" className={classes.youtube_iframe} >
                //</div>
            //{(VimeoType === true) ?

    return (
        <React.Fragment>
            {(props.PlayerType === "vimeo") &&
                <div id="vimeo_player_container" className={classes.player_container}>
                    <iframe id="drill_output"
                        src={VideoURL}
                        url={VideoURL}
                        className={classes.vimeo_iframe}
                        frameBorder="0"
                        allowFullScreen>
                    </iframe>
                </div>}

            {(props.PlayerType === "youtube") &&
                <YouTube id="drill_output" videoId={VideoID} opts={Opts} 
                    containerClassName={classes.player_container}
                    className={classes.youtube_iframe}
                    onReady={handleYoutubeOnReady} 
                    onStateChange={handleYoutubeOnStateChange} 
                    onEnd={handleYoutubeOnReady}>
                    {/* import YouTube from 'react-youtube'; */ }
                    {/* <YouTube videoId="2g811Eo7K8U" opts={opts} onReady={this.videoOnReady} ></YouTube> */}
                    {/* src: https://github.com/tjallingt/react-youtube */}
                    {/* ref: https://stackoverflow.com/questions/67644919/extracting-play-function-of-react-youtube-in-state-to-use-in-button-oncluck-resu */}
                </YouTube>}

            {(props.PlayerType === "native") &&
                <div id="vimeo_player_container" className={classes.player_native_container}>
                    <video id="drill_output" playsInline autoPlay muted={true} onLoadStart={handleNativeOnReady}
                        onPause={handleNativeOnStateChange} 
                        src={VideoURL} controls={true} crossOrigin='anonymous'
                        position="relative" width={props.Width} height={props.Height}
                        type="video/mp4" style={{display: "block", height: ""}} />
                </div>}


            {(props.ShowVideoControl) &&
                <VideoControl 
                    Play={handlePlayerPlay} 
                    Step={handlePlayerStep} 
                    Speed={handlePlayerSpeed} />
            } 

        </React.Fragment>
    )
}



const vidctl_useStyles = makeStyles(theme => ({
    vidctl_root: {
        position: 'absolute',
        bottom: "40px",      // 80px, '15%',
        left: '30px',
        padding: '0px 20px',
        margin: '0 0 10px 0',
        width: 'calc(100% - 10px)',     //90px)',
        height: '45px',     // 35px, 7vh, "9vh", '10%',
        overflow: 'auto',
        maxWidth: '100%',
        zIndex: '190',
    },
    vidctl_container: {
        padding: '0',
        margin: '0',
        //left: '0',
    },
    player_btn: {
        fontSize: '0.6rem',
        padding: '0',
        background: '#ffffff60',
        height: '35px',      // 6vh
        margin: '0px 2px 10px 2px',
    },
    delete_btn: {
        fontSize: '0.6rem',
        padding: '0',
        background: '#ff000060',
        color: 'white',
        height: '35px',      // 6vh
        margin: '0px 2px 10px 60px',
    },
    view_btn: {
        position: 'absolute',
        bottom: "55px",      // 80px, '15%',
        left: '0',
        padding: '0',
        background: '#ffffff40',
        height: '35px',      // 6vh
        minWidth: '40px',
        margin: '0px 2px',
        zIndex: '195',
        //bottom: '0',
        //left: '0',
    },
    footage_list_container: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        right: '0',
        top: '15%',
        padding: '0',
        margin: '0',
        width: '80px',
        height: '60%',      // 60%
        zIndex: '190',
        flexDirection: 'column',
        alignItems: 'center',
        //background: 'green',
        overflow: 'auto',
    },
    footage_button: {
        display: 'flex',
        position: 'relative',
        width: '60px',
        height: '30px',
        margin: '4px',
        fontSize: '0.7rem',
        overflow: 'wrap',
        background: '#ffffff50',
    },

}));


// display horizontal video player control
//
export const VideoControl = (props) => {
    const classes = vidctl_useStyles();
    const [ SpeedIndex, setSpeedIndex ] = useState(null);
    const [ MockType, setMockType ] = useState(null);
    const [ EditMode, setEditMode ] = useState(false);
    const [ Visible, setVisible ] = useState(false);

    useEffect(() => {
    }, [1]);


    useEffect(() => {
        var cspeed = INFO.mock_playing_speed;
        var idx = 0;
        for(var i = 0; i < CONSTS.MOCK_PLAYER_SPEEDS.length; i++) {
            var speed = CONSTS.MOCK_PLAYER_SPEEDS[i]
            if (cspeed == speed) {
                idx = i;
                break;
            }
        }
        setSpeedIndex(idx)

    }, [SpeedIndex, INFO.mock_playing_speed]);


    useEffect(() => {
        setMockType(INFO.mock_type);
    }, [INFO.mock_type]);


    useEffect(() => {
        //console.log("vid.783:     . . . . NEW FOOTAGES  ",props.Footages);
    }, [props.Footages]);



    const handleSetSpeed = () => {
        var index = (SpeedIndex >= (CONSTS.MOCK_PLAYER_SPEEDS.length - 1)) ? 0 : (SpeedIndex + 1);
        setSpeedIndex(index);
        props.Speed(CONSTS.MOCK_PLAYER_SPEEDS[index]);
        console.log("vid.942:     . . . . CHANGE SPEED TO ", (CONSTS.MOCK_PLAYER_SPEEDS[index]), "  ", props);
    }

    const handleVisible = () => {
        if (Visible === true) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    }

    const handleEditMode = () => {
        if (EditMode === true) {
            setEditMode(false);
        } else {
            setEditMode(true);
        }
        props.Edit();
    }


    const handleFootage = (timeline) => (event) => {
        console.log("vid.808:     . . . . PROCESS FOOTAGE  timeline=",timeline);
        props.HandleFootage(timeline);
    }




    return (
        <React.Fragment>
            <Button id="view_btn" className={classes.view_btn} onClick={handleVisible} >
                <FontAwesomeIcon 
                    className={classes.bug_icon}
                    icon={faEye}
                    style={{ fontSize: "1.3rem", color: "#333333a0"}} />
            </Button>

            {Visible && 
            <React.Fragment>
                <Container id="vidctl_root" className={classes.vidctl_root} >
                    <Container id="vidctl_container" className={classes.vidctl_container} >
                        <Button id="setting_btn" className={classes.player_btn} onClick={props.Play} >
                            PLAY
                        </Button>

                        <Button id="setting_btn" className={classes.player_btn} onClick={props.Step(-20)} >
                            B20
                        </Button>
                        <Button id="setting_btn" className={classes.player_btn} onClick={props.Step(-1)} >
                            B1
                        </Button>
                        <Button id="setting_btn" className={classes.player_btn} onClick={props.Step(1)} >
                            F1
                        </Button>
                        <Button id="setting_btn" className={classes.player_btn} onClick={props.Step(20)} >
                            F20
                        </Button>
                        <Button id="setting_btn" className={classes.player_btn} onClick={handleSetSpeed} >
                           {(CONSTS.MOCK_PLAYER_SPEEDS[SpeedIndex] * 100) + "%"} 
                        </Button>

                        {props.Mode && 
                        <React.Fragment>
                            <Button id="setting_btn" className={classes.player_btn} onClick={props.Mode} >
                            {MockType} 
                            </Button>
                            <Button id="setting_btn" className={classes.player_btn} onClick={props.Clear} >
                            CLEAR
                            </Button>
                            <Button id="setting_btn" className={classes.player_btn} onClick={handleEditMode} >
                            EDIT
                            </Button>
                            {EditMode && <Button id="setting_btn" className={classes.player_btn} onClick={props.Save} >
                            SAVE
                            </Button>}
                            {EditMode && <Button id="setting_btn" className={classes.delete_btn} onClick={props.Delete} >
                            DEL
                            </Button>} 
                        </React.Fragment> }
                    </Container>
                </Container>

                <Container id="footage_list" className={classes.footage_list_container} >
                    {props.Footages && props.Footages.map((footage, index1) => {
                        return(
                            <Button id={"foot"+index1} 
                                key={"foot"+index1}  
                                className={classes.footage_button}
                                onClick={handleFootage(footage.timeline)}>
                                    {footage.timeline.toString().substr(-7, 7)}
                            </Button>
                        )
                    }) }

                </Container>
            </React.Fragment>
            }
        </React.Fragment>
    )
}



// VOD VIDEOS SUPPORTS ***VIMEO ONLY***
//     - No need to use <Video_Frame>!
//
const vid_useStyles = makeStyles(theme => ({
    video_container: {
        display: "flex",
        position: 'relative',
        top: '0',
        padding: '3px',
        margin: '0',
        width: "auto",
        height: "auto",
        flexDirection: "column",
        justifySelf: "flex-start",
        alignSelf: "center",        // in case not covering 100%
        //background: '#6f6f74',
    },

    tut_vid_container: {
        display: "block",
        flexDirection: "column",
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        height: 'calc(100% - 30px)',
        width: "100%",
        //background: '#6f6f74',
    },
    tut_text: {
        margin: '0',
        padding: '5%',
        marginTop: CONSTS.GOBACK_BAR_HEIGHT,
		fontSize: '1.3rem',
        alignSelf: 'center',
        color: '#dee3f1',
        //background: '#6f6f74',
        lineHeight: '1.4rem',
    },
    tut_vid_iframe: {
        margin: '0',
        padding: '0',
        width: '100%',
        //height: 'calc(100% - 10px)',
        height: '100%',
        background: '#18181980',
    },

    drill_title_container: {
        overflow: 'hidden',
        fontWeight: 'bold',
        fontSize: '0.85rem',
        color: '#5d5c5c',
        padding: "0 0 0 3px",
        marginBottom: '8px',
        width: 'calc(100% - 25px)',
        //width: '150%',
        height: '30px',
        justifySelf: 'start',
    },

    scores_carousel_container: {
        display: "flex",
        flexDirection: "column",
        height: '100%',
        overflow: 'hidden',
        padding: '0',
        margin: '0',
    },
    scores_carousel_item: {
        flexDirection: "column",
        height: 'calc(100% - 50px)',
        padding: '0',
        margin: '0',
        justifyContent: 'flex-start',
    },
    dash_drill_btn: {
        position: 'absolute',
        right: '0',
        top: '0',
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        background: 'rgba(230, 230, 230, 0.99)',
        zIndex: '300',
    },
    fullscreen_btn: {
        position: 'absolute',
        right: '35px',
        bottom: '20px',
        color:'#e8e8e8',       //'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        zIndex: '300',
    },
    first_play_btn: {
        position: 'absolute',
        top: 'calc(50% - 17px)',
        left: 'calc(50% - 17px)',
        bottom: '50%',
        color:'#e8e8e8',       //'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        zIndex: '300',
    },
    avatar_container: {
        display: 'flex',
        flexDirection: "row",
        position: 'absolute',
        left: '40px',
        bottom: '20px',
        margin: '0px',
        padding: '0px',
        alignContent: 'center',
        background: '#3f3c3c7a',
        width: 'auto',
    },
    drill_result_text: {
        width: 'auto',
        fontSize: '0.85rem',
        color: '#fff',
        padding: "0 5px 0 8px",
        //width: 'calc(100% - 25px)',
        //background: '#3f3c3c7a',
        alignSelf: 'center',
    },
    no_vod_container: {
        padding: '25% 0', 
        color: '#3c3c3c', 
        textAlign: 'center',
        minWidth: '250px',
    },
}));


// SUPPORT VOD USE CASE - NOT GENERIC!
//      - show interesting record videos-of-the-day
//
export const VideoFeed = (props) => {
    const classes = vid_useStyles();
    const aclasses = marquee_styles;
    const Classes = UTIL_useStyles();
    const [ Videos, setVideos ] = useState(null);
    const [CardIndex, setCardIndex] = useState(0);
    const [LastIndex, setLastIndex] = useState(null);
    const [CardChanged, setCardChanged] = useState(false);
    const [ShowDrillButton, setShowDrillButton] = useState(false);
    const [ShowPlayButton, setShowPlayButton] = useState(true);
    const [AvatarText, setAvatarText] = useState("");
    const [Refresh, setRefresh] = useState(0);

    useEffect(() => {
        console.log("vid_feed.2186:  ######## START VIDEO-OF-DAY   ",props.Videos);
        /*
        playVideo(0);
        setCardIndex(0);
        */

        //setVideos(props.Videos);
        //setTimeout(checkCarousel(CardChanged), 5000);      // switch to let user know it's switchable
    }, [1]);


    useEffect(() => {
        if ((videos === null) || (videos === undefined)) return

        var videos = props.Videos;
        if ((videos.length === 0)) {
            setShowDrillButton(false);
            setVideos([]);
            return;
        }

        console.log("vid_feed.3134:  VIDEO-OF-DAY REFRESH   ",props.Videos.length);
        //setShowDrillButton(true);
        setVideos(props.Videos);

        setCardIndex(0);
        setTimeout(() => {
            console.log("vid_feed.3288:  .....DELAY PLAY VIDEO  ",props.Videos.length);
            playVideo(CardIndex);
        }, 100);
    }, [props.Videos]);


    // KLDUGE: NEED TO SET TO "false"
    //let vconsole_log = (true) ? console.log : () => {} 		// true will enable console.log
    //console.log("1242.vid:    - - - - - - > ", vconsole_log)

    useEffect(() => {
        var videos = [];
        var users = [];
        var leaders = INFO.db_news;
        //var leaders = props.News;
        if ((leaders === null) || (leaders === undefined) || (leaders.length === 0)) return;

        // first pass,dedup to one video per drill, select best user
        //      - only show drills the user can do
        //
        leaders.sort(arrayTargetHashAscSort);       // go by the heirarchy
        //var last_drill = leaders[0].target_hash.split("+")[0];
        var last_drill = null;
        var possibles = [];

        console.log("vid.3149:  ######## PROCESS VOD  leaders=", leaders);
        for (var i = 0; i < leaders.length; i++) {
            var leader = leaders[i];
            var drill_hash = leader.target_hash.split("+")[0];

            var owns_drill = INFO.db_drills.filter(drill => {
                    return (drill.hash == drill_hash);      // owns this drill
                })

            var did_video = videos.filter(player => {
                    var pdrill_hash = player.target_hash.split("+")[0];
                    var ldrill_hash = leader.target_hash.split("+")[0];
                    return (pdrill_hash == ldrill_hash);        // drill has not been used already
                })

            if ((owns_drill.length === 0) || (did_video.length > 0))  {
                last_drill = drill_hash;
                //console.log("vid.3132:      .........SKIP INELIGIBLE VIDEO  ",i,"    ",drill_hash, " owns_drill=", owns_drill.length, "  did_vidoe=",did_video.length);
                continue;
            }
            var drill_name = owns_drill[0].name.toUpperCase();

            if (drill_hash !== last_drill) {
                // start of a new drill
                //
                //console.log("vid.3172:  FOUND NEW DRILL   ",i,"    ",drill_hash, " last_drill=", last_drill, " possibles=",possibles.length);
                if(possibles.length > 0) {
                    // go through possibles, insert into videos
                    var idx = null;
                    var low_cnt = 9999;
                    for (var j = 0; j < possibles.length; j++) {
                        var possible = possibles[j];
                        if (possible.use_cnt < low_cnt) {
                            idx = j;
                            low_cnt = possible.use_cnt;
                        }
                    }

                    //console.log("vid.3132:      +++++++++INSERT  ",i,"    idx=",idx, " ",possibles[idx]);
                    videos.push(possibles[idx]);
                    possibles = [];     // done, reset it
                }
            }


            if ((leader.video !== undefined) && (leader.video !== "")) {
                    // found a legit leaderboard with video, score it
                    //
                    var did_player = users.filter(user => { return (user == leader.user_id); })

                    if(leader.video.includes("vimeo") === true) {
                        // VOD must be vimeo videos
                        //
                        var url = makeVideoLink(leader.video, "leader.1287"); // src=https://vimeo.com/584700710
                        leader.url = url;
                        leader.video  = url;

                        //leader.url = leader.video;       // play auto-gen internal video
                        //leader.title = leader.title.toUpperCase();

                        leader.title = drill_name;
                        leader.use_cnt = did_player.length;     // lower the better
                        //console.log("vid.3380:      .........POSSIBLE  ",i,"    vid=",leader.video, " target_hash=",leader.target_hash, " ");    //, leader;

                        possibles.push(leader);
                        users.push(leader.user_id);     // we want to show as many users as we can
                    }

            } else {
                //console.log("vid.3205:  NO VIDEO SKIP DRILL   ",i,"    ",drill_hash);

            }
            last_drill = drill_hash;

        }

        videos.sort(arraySourceTimestampDesSort); 
        console.log("vid.1337: ============ FINAL LEADER VIDEOS ",videos);
        setVideos(videos);      // put newest first
        setCardIndex(0);
        setShowDrillButton(true);

    //}, [INFO.db_news]);
    }, [props.News]);


    useEffect(() => {
        //console.log("vod.2193:      Refresh Video-of-day   props.Videos=",Videos);

        //setVideos(props.Videos);
        //if ((props.Videos !== undefined) && (props.Videos[CardIndex] !== undefined)) {
        if ((Videos) && (Videos[CardIndex] !== undefined)) {
            GATag("Dashboard", "VOD.Select", Videos[CardIndex].title, 0);		 // (cat, act, lab, val)
        }
    }, [CardIndex, Videos, AvatarText, Refresh]);


    useEffect(() => {
        if (Videos) {
          setTimeout(() => {
              console.log("vid_feed.3288:  .....DELAY PLAY VIDEO  ",Videos.length);
              playVideo(0);     // was 
          }, 300);
        }
    }, [ Videos ]);

    const handleVideoSelect = (index, e) => {
        var video = Videos[index];
        console.log("vod.2198:  Score new index=",index, "  ", Videos[index]);
        setCardIndex(index);
        playVideo(index);
        setShowDrillButton(true);

        setCardChanged(true);
    };




    // UTIL
    // get the iframe from the carousel and return the player
    //
    const getPlayer = (index) => {
        var player = null;
        var iframe = document.getElementById("video_"+index);
        if ((iframe !== undefined) && (iframe !== null)) {


            // NEED TO CONVERT TO VIDEO_FRAME


            player = new VimeoPlayer(iframe);       // VOD
        }
        return player;
    }


    const  handlePlayVideo = (index) => (event) => {
        console.log('vod_play.3272:   ....ENTER HANDLE PLAY_VIDEO  ', index);
        //playVideo(index);

        var player = getPlayer(index);
        player.play();
    }



    const  handleFullScreen = (index) => (event) => {
        console.log('vod_play.3272:   ....ENTER HANDLE FULLSCREEN  ', index);
        //playVideo(index);

        var player = getPlayer(index);
        player.requestFullscreen().then(function() {
            // the player entered fullscreen
        }).catch(function(error) {
            // an error occurred
        });
    }


    // Support VOD carosel
    //
    // ref: https://github.com/vimeo/player.js/
    const  playVideo = (index) => {
        var player;
        var idx = index;        // CardIndex
        var video = Videos[index];

        if ((video === undefined) || (video === null)) {
            /*
            console.log("vod_play.3484:        NO VIDEO  DELAYED  index=",index, " RECORD=" , Videos);
            setTimeout(() => {
                console.log("vid_feed.3485:  .....DELAY PLAY VIDEO  index=",index, "  ",props.Videos.length);
                playVideo(index);
            }, 100);
            */
            return;
        }
        // stop the old one
        player = getPlayer(LastIndex)
        if(player !== null) {
            console.log('vod_play.3274:        --------- PAUSE LAST VIDEO ', LastIndex);
            player.pause();
        }

        // play the new one
        player = getPlayer(idx)
        console.log('vod_play.3274:   ENTER PLAY_VIDEO  ', idx, "  player=", player);
        if(player !== null) {
            var avatar_text = null;
            if (video.field !== undefined) {
                let bits = video.user_full.split(" ")
                avatar_text = video.field.toUpperCase()+": "+parseInt(video.value);
                //avatar_text += "..."+video.user_id.toLowerCase()
                avatar_text += "  "+bits[0]
                setAvatarText(avatar_text);
            }
            console.log('vod_play.3274:        +++++++++ START PLAY VIDEO ', idx, " field=",avatar_text, " video=",video);
            player.play();

            player.on('loaded', function() {
                console.log('vod_play.3697:  ############## VIMEO LOADED!  ', idx);
                player.play()
                player.pause()
                setTimeout(function() { player.play() }, 500)
            })

            player.on('play', function() {
                console.log('vod_play.3704:  ############## VIMEO PLAYING!  ', idx);
                setShowPlayButton(false);
                //var speed = (INFO.slowmo_mode == true) ? 0.5 : 1.0;
                //setRefresh(Date.now());    // signal <Result> to refresh
                //player.play();
                //player.pause()
                //setTimeout(function() { player.play() }, 750)
            });
            setLastIndex(index);
            setRefresh(Date.now());
        }
    }


    function handleDrillAction() {
        // short cut to run the drill directly from the leaderboard
        //
        var target_hash = Videos[CardIndex].target_hash;
        var drill_hash = target_hash.split("+")[0]
        console.log("video.drill.1813:   Run Drill From Video-of-Day   idx==",CardIndex," ",Videos, "  target_hash=",drill_hash);
        props.DrillAction(target_hash)
    }


                    //onClick={handlePlayVideo(index1)}
                //<marquee behavirod="alternate" direction="up" scrollamount="4" scrolldelay="300" className={classes.vleader_title_text}> 
                                //<Container id="marqee_text" className={aclasses.news + classes.drill_title_text}> 

    // NOTE: KLUDGE - DO NOT CHANGE NAME OF "tut_video_container"
    //
    // marquee_src: https://www.techonthenet.com/html/elements/marquee_tag.php
    // css_animate: https://dev.to/samwatts98/how-to-easily-animate-your-react-components-on-click-with-css-keyframes-26mg
    return (
        <React.Fragment>
            { Videos ? 

              <Container id="videofeed" className={classes.video_container} >

                {(false && ShowDrillButton) && 
                   <Button id={"to_vod_btn"} className={classes.dash_drill_btn} onClick={handleDrillAction}>
                     <FontAwesomeIcon 
                        className={classes.bug_icon}
                        icon={faSun}
                        style={{ fontSize: "1.7rem"}} />
                  </Button>
                }

                <Carousel id="vod_carousel_container" 
                    interval={null} 
                    indicators={null}
                    activeIndex={CardIndex} 
                    onSelect={handleVideoSelect}
                    style= {{'height': props.Height - 20}}
                    className={classes.scores_carousel_container} >

                
                    {(Videos.length > 0) ? 
                      Videos.map((video, index1) => {
                          return(
                            <Carousel.Item  key={"video_carou_item_"+index1} 
                                    style= {{'height': props.Height }}
                                    className={classes.scores_carousel_item}>

                                <Container id="marqee_holder" className={classes.drill_title_container}> 
                                    <Container id="marqee_text" className={aclasses.news} style={{padding: '0', width: '140%'}}>
                                        {video.title+" OF THE DAY ("+(index1+1)+")"}
                                    </Container>
                                </Container>
                                <Container id="tut_video_container" className={classes.tut_vid_container} onClick={handlePlayVideo(index1)}>

                                    {(ShowPlayButton) && <Button id={"play_btn"} className={classes.first_play_btn} onClick={handlePlayVideo(index1)}>
                                        <FontAwesomeIcon 
                                            icon={faPlayCircle}
                                            style={{fontSize: "2.2rem"}} />
                                    </Button>}

                                    <iframe id={"video_"+index1}
                                            className={classes.tut_vid_iframe}
                                            src={video.url}
                                            frameBorder="0" 
                                            allowFullScreen>
                                    </iframe>

                                    {!ShowPlayButton && <Container id="avatar_container" className={classes.avatar_container}>
                                        <Avatar id="avatar9" Image={video.user_avatar} Style={{"height": "22px"}} />
                                        <Typography className={classes.drill_result_text}> {AvatarText} </Typography>
                                    </Container>}

                                    {!ShowPlayButton && <Button id={"fullscreen_btn"} className={classes.fullscreen_btn} onClick={handleFullScreen(index1)}>
                                        <FontAwesomeIcon 
                                            className={classes.bug_icon}
                                            icon={faExpand}
                                            style={{fontSize: "1.5rem"}} />
                                    </Button>}
                                </Container>
                            </Carousel.Item>
                        )
                      }) 

                  :
                      <Carousel.Item  key={"video_carou_item_no"} >
                        <Container id="no_vod"  className={classes.no_vod_container} style={{ height: props.Height }}>
                            NO VIDEO OF THE DAY
                        </Container>
                      </Carousel.Item>
                  }

                  </Carousel>
            </Container>

            :

            <React.Fragment>
              <Container id="marqee_holder" className={classes.drill_title_container}> 
                  <Container id="marqee_text" className={aclasses.news} style={{padding: '0', width: '140%'}}>
                      VIDEO OF THE DAY
                  </Container>
              </Container>

              <div role="status" style={{ display: "flex", 
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%", }}> 
                  <LoadingBars color="#ccc" size="0.5em" /> 
              </div>
            </React.Fragment>

          }


        </React.Fragment>
    )
}


